import './auto-complete-text-field.scss'

import { PropType } from "vue";
import Component from "vue-class-component";

import { FIELD_VALUE_UPDATED } from "../../events";
import { ReactiveVue } from "@skinsoft/reactive-vue";
import _ from 'lodash';

//type Orientation = 'Up' | 'Down'

@Component({
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        /*orientation: {
            type: String as PropType<Orientation>,
            default: 'Down',
        },*/
    },
    template: require("./auto-complete-text-field.html")
})
export class AutoCompleteTextField extends ReactiveVue {
    private availableValues: String[]
    private value: String
    private placeholder: String
    private readonly: Boolean
    //private orientation: Orientation

    private showSuggestions: boolean = false

    private get valueCopy(): String {
        return this.value
    }

    private set valueCopy(newValue: String) {
        this.$emit(FIELD_VALUE_UPDATED, newValue)
    }

    private get filteredSuggestions() {
        return this.availableValues.filter(value => {
            return value.includes(this.valueCopy as string) && value != this.valueCopy
        })
    }

    /*private get isOrientationUp() {
        return this.orientation === 'Up'
    }*/

    private onSuggestionClicked(value: string) {
        this.valueCopy = value
        this.showSuggestions = false
    }

    private onFocus(event: FocusEvent) {
        this.showSuggestions = true
    }

    private onBlur(event: FocusEvent) {
        setTimeout(
            () => {
                this.showSuggestions = false
            }, 
            100
        )
    }
}